/**
 * Product carousel cards: navigate to PDP from non-link card areas.
 * Horizontal scrolling uses native overflow / trackpad swipe only.
 */
(function () {
  if (window.__pcarCarouselCardsBound) return;
  window.__pcarCarouselCardsBound = true;

  function handleCardClick(event) {
    if (event.target.closest('.ds-swatch')) return;
    if (event.target.closest('a[href]')) return;

    const link =
      event.currentTarget.querySelector('.ds-product-card__link--details[href]') ||
      event.currentTarget.querySelector('.ds-product-card__link[href]');
    if (link) window.location.assign(link.href);
  }

  function bindCarouselCards(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.pcar-card:not(.pcar-card--shop-all)').forEach((card) => {
      if (card.dataset.pcarCardClickBound) return;
      card.dataset.pcarCardClickBound = 'true';
      card.addEventListener('click', handleCardClick);
    });
  }

  /* Swipe progress bar under each track (shown on mobile/tablet via CSS).
     The thumb width is the visible share of the row; it follows the scroll
     position 1:1 so it tracks the finger with no easing lag. */
  const progressByTrack = new WeakMap();
  const resizeObserver =
    'ResizeObserver' in window ? new ResizeObserver((entries) => entries.forEach((e) => measure(e.target))) : null;

  function measure(track) {
    const state = progressByTrack.get(track);
    if (!state) return;
    const { clientWidth, scrollWidth } = track;
    const overflow = scrollWidth - clientWidth;
    state.barWidth = state.bar.clientWidth;
    state.max = overflow;
    state.bar.classList.toggle('is-scrollable', overflow > 2 && clientWidth > 0);
    const share = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
    state.thumbWidth = Math.max(0.2, Math.min(1, share)) * state.barWidth;
    state.thumb.style.width = `${state.thumbWidth}px`;
    paint(track);
  }

  function paint(track) {
    const state = progressByTrack.get(track);
    if (!state) return;
    state.frame = 0;
    const progress = state.max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / state.max)) : 0;
    const x = progress * (state.barWidth - state.thumbWidth);
    state.thumb.style.transform = `translate3d(${x}px, 0, 0)`;
  }

  function onScroll(event) {
    const track = event.currentTarget;
    const state = progressByTrack.get(track);
    if (!state || state.frame) return;
    state.frame = requestAnimationFrame(() => paint(track));
  }

  function bindProgress(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const tracks = scope.matches && scope.matches('.pcar-track') ? [scope] : scope.querySelectorAll('.pcar-track');

    tracks.forEach((track) => {
      if (progressByTrack.has(track)) {
        measure(track);
        return;
      }
      const bar = document.createElement('div');
      bar.className = 'pcar-progress';
      bar.setAttribute('aria-hidden', 'true');
      const thumb = document.createElement('span');
      thumb.className = 'pcar-progress__thumb';
      bar.appendChild(thumb);
      track.insertAdjacentElement('afterend', bar);

      progressByTrack.set(track, { bar, thumb, barWidth: 0, thumbWidth: 0, max: 0, frame: 0 });
      track.addEventListener('scroll', onScroll, { passive: true });
      if (resizeObserver) {
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', () => measure(track));
      }
      measure(track);
    });
  }

  function init(root) {
    bindCarouselCards(root);
    bindProgress(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  // Cards mounted after load (featured-carousel hidden tabs).
  document.addEventListener('pcar:cards-mounted', (event) => {
    const root = event.detail && event.detail.root;
    bindCarouselCards(root);
    bindProgress(root);
  });
})();
